<div class="hero-section">
  <div class="hero-shell">
    <div class="hero-content">
      <p class="hero-eyebrow">POS + Mobile Apps</p>

      <h1 class="hero-title">
        <span class="hero-title-line">Run Your Sales and Stock</span>
        <span class="hero-title-line hero-title-line--second">from <span class="hero-title-highlight">POS, Mobile</span>, and Online Orders.</span>
      </h1>

      <p class="hero-description">
        Fast billing and inventory control on your POS. Manage your business from your phone
        and let customers place orders through your app. Everything stays connected.
      </p>

      <div class="hero-buttons">
        <button class="hero-btn hero-btn-primary" type="button" (click)="showRegister = true">Download &amp; Try</button>
        <a class="hero-btn hero-btn-secondary" href="https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-07" target="_blank" rel="noopener noreferrer">Book a meeting</a>
      </div>
    </div>

    <div class="hero-image" aria-hidden="true">
      <img src="images/webps/hero-pos.webp" alt="" />
    </div>
  </div>
</div>

<app-register
  *ngIf="showRegister"
  [selectedApps]="salesApp"
  (goBack)="showRegister = false"
></app-register>
